import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { AllProductLines } from 'self-service-api/constants/ProductLines';
import UIImage from 'UIComponents/image/UIImage';
import UIFlex from 'UIComponents/layout/UIFlex'; // @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'ui-a... Remove this comment to see the full error message

import { ProductLinePageIcons } from 'ui-addon-upgrades/_core/productPage/ProductPageIcons';
import { ProductLevelAndProductLineToSuiteBOTranslationKeyMap, ProductLevelToSuiteBOHeaderTranslationKeyMap } from '../../constants/BusinessObjectivesTranslationKeys';
import SuiteBusinessObjectivesSubtext from '../merch-card/business-objectives/SuiteBusinessObjectivesSubtext';
import UIAccordionItem from 'UIComponents/accordion/UIAccordionItem';
const StyledP = styled.p.withConfig({
  displayName: "MobileSuiteBusinessObjectives__StyledP",
  componentId: "xp42um-0"
})(["height:", ";"], ({
  addSpacing
}) => addSpacing ? '17px' : '0');

const MobileSuiteBusinessObjectives = ({
  productLevel,
  addSpacing = false
}) => {
  return /*#__PURE__*/_jsxs(UIAccordionItem, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "merchCards.businessObjectives.seeDetails"
    }),
    children: [/*#__PURE__*/_jsx("div", {
      className: "p-bottom-4",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: ProductLevelToSuiteBOHeaderTranslationKeyMap[productLevel]
      })
    }), AllProductLines.map(localProductLine => {
      return /*#__PURE__*/_jsxs(UIFlex, {
        className: "m-y-1",
        children: [/*#__PURE__*/_jsx(UIImage, {
          className: "display-inline m-right-3",
          src: ProductLinePageIcons[localProductLine]
        }), /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: ProductLevelAndProductLineToSuiteBOTranslationKeyMap[productLevel][localProductLine].title
          }), /*#__PURE__*/_jsx(StyledP, {
            addSpacing: addSpacing,
            children: /*#__PURE__*/_jsx(SuiteBusinessObjectivesSubtext, {
              productLevel: productLevel,
              productLine: localProductLine
            })
          })]
        })]
      }, localProductLine);
    })]
  });
};

export default MobileSuiteBusinessObjectives;